import { render, staticRenderFns } from "./AppTag.vue?vue&type=template&id=04712db2&"
import script from "./AppTag.vue?vue&type=script&lang=js&"
export * from "./AppTag.vue?vue&type=script&lang=js&"
import style0 from "./AppTag.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports